export const c_background_image_Filter = {
  "name": "--pf-c-background-image--Filter",
  "value": "url(\"#image_overlay\")",
  "var": "var(--pf-c-background-image--Filter)"
};
export default c_background_image_Filter;